import { render, staticRenderFns } from "./Release.vue?vue&type=template&id=558ab7fc&"
import script from "./Release.vue?vue&type=script&lang=js&"
export * from "./Release.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Release.vue"
export default component.exports